export var PillStateType;
(function (PillStateType) {
    PillStateType["DEFAULT"] = "DEFAULT";
    PillStateType["SELECTED"] = "SELECTED";
    PillStateType["DISABLED"] = "DISABLED";
    PillStateType["DISABLED_SELECTED"] = "DISABLED_SELECTED";
})(PillStateType || (PillStateType = {}));
export { PillStateType as PillStateTypeV2 };
//# sourceMappingURL=pillStateType.js.map